import { render, staticRenderFns } from "./CumplimientoPLXArea.vue?vue&type=template&id=66279cd9&scoped=true&"
import script from "./CumplimientoPLXArea.vue?vue&type=script&lang=js&"
export * from "./CumplimientoPLXArea.vue?vue&type=script&lang=js&"
import style0 from "./CumplimientoPLXArea.vue?vue&type=style&index=0&id=66279cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66279cd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
